import Vue from 'vue';
import Vuex, { GetterTree, MutationTree, StoreOptions } from 'vuex';
import auth from '@/store/auth';
import user from '@/store/models/user';
import enterprises from '@/store/models/work/enterprises';
import { PageMeta } from '@/store/types/pagination';
import { pub } from '@/store/models/pub';
import { Enterprise } from '@/store/types/public/Enterprise';

export const ITEMS_REQUEST = 'request';
export const SHOW_REQUEST = 'show';
export const GET_ITEMS = 'items';
export const GET_ITEM = 'item';
export const GET_STATUS = 'status';
export const LOADING = 'loading';
export const META = 'meta';

export interface RootState {
  status: boolean|null,
  error?: any
  items: any[],
  item?: object,
  meta?: PageMeta
}

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  state: {
    title: ''
  },
  getters: {
    getTitle: (state:any) => state.title
  },
  mutations: {
    setTitle: (state:any, title: string) => { state.title = title; }
  },
  actions: {
  },
  modules: {
    auth: auth,
    user: user,
    work: {
      namespaced: true,
      modules: {
        enterprises: enterprises
      }
    },
    pub: pub
  },
  strict: debug
});
